import { createAction, props } from '@ngrx/store';

export const saveKeyValue = createAction(
  '[COMMON] Save key value',
  props<{
    value: any;
    key: string;
  }>()
);
